import styled from "@emotion/styled";

interface StyledTooltipTitleProps {
  colour: string;
}

export const StyledTooltipTitle = styled.div`
  color: ${(props: StyledTooltipTitleProps) => props.colour};
  font-weight: 800;
`;
